"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = __importStar(require("react"));
const prop_types_1 = __importDefault(require("prop-types"));
const moment_1 = __importDefault(require("@date-io/moment"));
const moment_2 = __importDefault(require("moment"));
const pickers_1 = require("@material-ui/pickers");
const styles_1 = require("@material-ui/core/styles");
const Typography_1 = __importDefault(require("@material-ui/core/Typography"));
const formik_1 = require("formik");
const useStyles = styles_1.makeStyles((theme) => ({
    root: {
        '& svg': {
            fill: theme.palette.primary.main,
        },
    },
}));
const RenderDateField = (props) => {
    const { field: { value, name }, form: { touched, errors, setFieldValue, setFieldTouched }, fieldLabel, placeholder, minDate, maxDate, minDateMessage, maxDateMessage, disablePast, disableFuture, onValueChange = () => undefined, ...otherProps } = props;
    const classes = useStyles();
    const error = formik_1.getIn(errors, name);
    const touch = formik_1.getIn(touched, name);
    return (react_1.default.createElement(react_1.Fragment, null,
        react_1.default.createElement(pickers_1.MuiPickersUtilsProvider, { libInstance: moment_2.default, utils: moment_1.default },
            react_1.default.createElement(pickers_1.KeyboardDatePicker, Object.assign({ name: name, format: "LL", InputAdornmentProps: { id: `mui-component-calendar-${name}`, classes: { root: classes.root } }, value: value || null, onChange: (value, strInput) => {
                    let newVal = value;
                    if (moment_2.default(strInput, 'MM/DD/YYYY', true).isValid()) {
                        newVal = moment_2.default(strInput, 'MM/DD/YYYY', true);
                    }
                    setFieldValue(name, newVal);
                    onValueChange(newVal);
                }, onBlur: () => setFieldTouched(name, true), invalidDateMessage: null, error: touch && !!error, autoOk: true, placeholder: placeholder, variant: "inline", inputVariant: "filled", fullWidth: true, disableToolbar: true, disablePast: disablePast, disableFuture: disableFuture, minDate: minDate ? moment_2.default(minDate).format('YYYY-MM-DD') : undefined, maxDate: maxDate ? moment_2.default(maxDate).format('YYYY-MM-DD') : undefined, minDateMessage: true, maxDateMessage: true, mask: "__/__/____", allowKeyboardControl: false, label: fieldLabel }, otherProps))),
        touch && !!error && (react_1.default.createElement(Typography_1.default, Object.assign({ variant: "body2", component: "p", color: "error" }, otherProps), error))));
};
RenderDateField.defaultProps = {
    minDate: moment_2.default().format('YYYY-MM-DD'),
    minDateMessage: '',
    maxDateMessage: '',
    disablePast: true,
    disableFuture: undefined,
};
RenderDateField.propTypes = {
    field: prop_types_1.default.any.isRequired,
    form: prop_types_1.default.any.isRequired,
    fieldLabel: prop_types_1.default.string.isRequired,
    placeholder: prop_types_1.default.string,
    onValueChange: prop_types_1.default.func,
};
exports.default = RenderDateField;
